import { render, staticRenderFns } from "./StoreItem.vue?vue&type=template&id=6b5c92d8&scoped=true&"
import script from "./StoreItem.vue?vue&type=script&lang=js&"
export * from "./StoreItem.vue?vue&type=script&lang=js&"
import style0 from "./StoreItem.vue?vue&type=style&index=0&id=6b5c92d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5c92d8",
  null
  
)

export default component.exports